export enum LicenseProductIdEnum {
  ProductIdCeps = 2656,
  ProductIdVifor = 2435,
  ProductIdEpcAdvanced = 2593,
  ProductIdEpcDesktops = 2797,
  ProductIdEpcDesktopsExtended = 3061,
  ProductIdEpcServers = 2592,
  ProductIdEpcServersExtended = 3062,
  ProductIdGlobal = 2612,
  ProductIdSos = 2692,
  ProductIdMdm = 2594,
  ProductIdOfficeSecurityPack = 2759,
  ProductIdSveCpu = 2597,
  ProductIdSveCpuExtended = 3065,
  ProductIdSveVdi = 2595,
  ProductIdSveVdiExtended = 3063,
  ProductIdSveVs = 2596,
  ProductIdSveVsExtended = 3064,
  ProductIdBusinessSecurityPack = 2760,
  ProductIdEnterprisePoolsAbsPack = 2893,
  ProductIdNextGen = 2883,
  ProductIdNextGenExtended = 2894,
  ProductIdAtd = 2892,
  ProductIdEdrHybridAddon = 3049,
  ProductIdEarlyAccess = 3057,
  ProductIdRemoteAccess = 3123,
  ProductIdVolumeEncryption = 2870,
  ProductIdPatchManagement = 2897,
  ProductIdStorageProtection = 2906,
  ProductIdHdSandbox = 2907,
  ProductIdSandboxLocal = 2911,
  ProductIdExchangeServers = 2762,
  ProductIdContainerProtection = 3070,
  ProductIdEmailSecurity = 2986,
  ProductIdMobileSecurity = 2987,
  ProductIdEdrEs30DaysStorage = 3052,
  ProductIdEdrEs90DaysStorage = 3051,
  ProductIdEdrEs180DaysStorage = 3053,
  ProductIdEdrEs365DaysStorage = 3132,
  ProductIdNtsaServers = 2919,
  ProductIdNtsaClientDevices = 2916,
  ProductIdNtsaThroughput = 2985,
  ProductIdCompanion = 3054,
  ProductIdMsp = 2765,
  ProductIdFrat = 3033,
  ProductIdDesktopSecurity = 3110,
  ProductIdServerSecurity = 3111,
  ProductIdXdrBundle = 3115,
  ProductIdXdrProductivitySensors = 3116,
  ProductIdXdrNetworkSensors = 3117,
  ProductIdXdrCloudSensors = 3118,
  ProductIdXdrIdentitySensors = 3119,
  ProductIdIntegrityMonitorAddon = 3126,
  ProductIdIntegrityMonitorEs90DaysStorage = 3127,
  ProductIdIntegrityMonitorEs180DaysStorage = 3128,
  ProductIdIntegrityMonitorEs365DaysStorage = 3129,
  ProductIdCoreOnlineProduct = 3150,
  ProductIdNadAndEraAddon = 3151,
  ProductIdWebAccessAndDeviceControlAddon = 3152,
  // Formerly ProductIdMdrFoundations
  ProductIdMdr = 3153,
  ProductIdMdrPremium = 3154,
  // Formerly ProductIdMdrEnterprise
  ProductIdMdrPlus = 3155,
  ProductIdBreachWarranty = 1609,
  ProductIdBreachWarrantyPlus = 1610,
  ProductIdBreachWarrantyPlusOver1000 = 1613,
  ProductIdCws = 3156,
  ProductIdXdrSensitiveDataSensors = 3120,
  ProductIdComplianceManager = 3161,
  ProductIdPhasrAddon = 3160,
  ProductIdExposureManagement = 3159,
}

export const PRODUCTS_WITH_EDR = [
  LicenseProductIdEnum.ProductIdAtd,
  LicenseProductIdEnum.ProductIdEdrHybridAddon,
  LicenseProductIdEnum.ProductIdMsp,
  LicenseProductIdEnum.ProductIdCompanion,
  LicenseProductIdEnum.ProductIdXdrBundle,
];

export const PRODUCTS_WITH_MDR = [
  LicenseProductIdEnum.ProductIdMdr,
  LicenseProductIdEnum.ProductIdMdrPremium,
  LicenseProductIdEnum.ProductIdMdrPlus,
];

export const BREACH_WARRANTY_PRODUCTS = [
  LicenseProductIdEnum.ProductIdBreachWarranty,
  LicenseProductIdEnum.ProductIdBreachWarrantyPlus,
  LicenseProductIdEnum.ProductIdBreachWarrantyPlusOver1000,
];

export const PRODUCT_ID_TO_NAME = {
  [LicenseProductIdEnum.ProductIdCeps]: () => 'Bitdefender Small Office Security (Cloud Console)',
  [LicenseProductIdEnum.ProductIdVifor]: () => 'Cloud Security for Endpoints',
  [LicenseProductIdEnum.ProductIdEpcAdvanced]: () => 'GravityZone Physical Endpoints Advanced',
  [LicenseProductIdEnum.ProductIdEpcDesktops]: () => 'GravityZone Security for Endpoints Physical Workstations',
  [LicenseProductIdEnum.ProductIdEpcDesktopsExtended]: () => 'GravityZone Security for Endpoints Physical Workstations',
  [LicenseProductIdEnum.ProductIdEpcServers]: () => 'GravityZone Security for Endpoints Physical Servers',
  [LicenseProductIdEnum.ProductIdEpcServersExtended]: () => 'GravityZone Security for Endpoints Physical Servers',
  [LicenseProductIdEnum.ProductIdGlobal]: () => 'GravityZone-in-a-box',
  [LicenseProductIdEnum.ProductIdSos]: () => 'Bitdefender Small Office Security (On-premise Console)',
  [LicenseProductIdEnum.ProductIdMdm]: () => 'GravityZone Security for Mobile Devices',
  [LicenseProductIdEnum.ProductIdSveCpu]: () => 'GravityZone Security per CPU license',
  [LicenseProductIdEnum.ProductIdSveCpuExtended]: () => 'GravityZone Security for Virtual Env per CPU',
  [LicenseProductIdEnum.ProductIdSveVdi]: () => 'GravityZone Security for VDI',
  [LicenseProductIdEnum.ProductIdSveVdiExtended]: () => 'GravityZone Security for Virtualized Environments VDI',
  [LicenseProductIdEnum.ProductIdSveVs]: () => 'GravityZone Security for Virtual Servers',
  [LicenseProductIdEnum.ProductIdSveVsExtended]: () => 'GravityZone Security for Virtualized Environments VS',
  [LicenseProductIdEnum.ProductIdExchangeServers]: () => 'GravityZone Security for Exchange Servers',
  [LicenseProductIdEnum.ProductIdOfficeSecurityPack]: () => 'GravityZone Business Security',
  [LicenseProductIdEnum.ProductIdBusinessSecurityPack]: () => 'GravityZone Advanced Business Security',
  [LicenseProductIdEnum.ProductIdEnterprisePoolsAbsPack]: () => 'GravityZone Advanced Business Security',
  [LicenseProductIdEnum.ProductIdNextGen]: () => 'GravityZone Business Security Premium',
  [LicenseProductIdEnum.ProductIdNextGenExtended]: () => 'GravityZone Elite',
  [LicenseProductIdEnum.ProductIdAtd]: () => 'GravityZone Business Security Enterprise',
  [LicenseProductIdEnum.ProductIdEarlyAccess]: () => 'GravityZone XDR - Early Access Program',
  [LicenseProductIdEnum.ProductIdRemoteAccess]: () => 'GravityZone XDR - Remote Shell',
  [LicenseProductIdEnum.ProductIdVolumeEncryption]: () => 'GravityZone Full Disk Encryption',
  [LicenseProductIdEnum.ProductIdPatchManagement]: () => 'GravityZone Patch Management',
  [LicenseProductIdEnum.ProductIdStorageProtection]: () => 'GravityZone Security for Storage',
  [LicenseProductIdEnum.ProductIdHdSandbox]: () => 'GravityZone HD Add-on (HyperDetect, Sandbox)',
  [LicenseProductIdEnum.ProductIdSandboxLocal]: () => 'GravityZone Sandbox Analyzer On Premises',
  [LicenseProductIdEnum.ProductIdNtsaServers]: () => 'Network Traffic Security Analytics (NTSA)',
  [LicenseProductIdEnum.ProductIdNtsaClientDevices]: () => 'Network Traffic Security Analytics (NTSA)',
  [LicenseProductIdEnum.ProductIdNtsaThroughput]: () => 'Network Traffic Security Analytics (NTSA)',
  [LicenseProductIdEnum.ProductIdContainerProtection]: () => 'GravityZone Security for Containers',
  [LicenseProductIdEnum.ProductIdEdrHybridAddon]: () => 'GravityZone Endpoint Detection and Response',
  [LicenseProductIdEnum.ProductIdEmailSecurity]: () => 'GravityZone Security for Email',
  [LicenseProductIdEnum.ProductIdMobileSecurity]: () => 'GravityZone Security for Mobile',
  [LicenseProductIdEnum.ProductIdCws]: () => 'GravityZone CSPM+',
  [LicenseProductIdEnum.ProductIdEdrEs30DaysStorage]: () => 'GravityZone EDR 30 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdEdrEs90DaysStorage]: () => 'GravityZone EDR 90 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdEdrEs180DaysStorage]: () => 'GravityZone EDR 180 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdEdrEs365DaysStorage]: () => 'GravityZone EDR 365 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdCompanion]: () => 'GravityZone EDR Cloud',
  [LicenseProductIdEnum.ProductIdMsp]: () => 'Cloud Security for MSP',
  [LicenseProductIdEnum.ProductIdFrat]: () => 'Free Risk Assessment Tool',
  [LicenseProductIdEnum.ProductIdDesktopSecurity]: () => 'GravityZone Security for Workstations',
  [LicenseProductIdEnum.ProductIdServerSecurity]: () => 'GravityZone Security for Servers',
  [LicenseProductIdEnum.ProductIdXdrProductivitySensors]: () => 'Bitdefender XDR Sensor - Productivity',
  [LicenseProductIdEnum.ProductIdXdrCloudSensors]: () => 'Bitdefender XDR Sensor - Cloud',
  [LicenseProductIdEnum.ProductIdXdrIdentitySensors]: () => 'Bitdefender XDR Sensor - Identity',
  [LicenseProductIdEnum.ProductIdXdrNetworkSensors]: () => 'Bitdefender XDR Sensor - Network',
  [LicenseProductIdEnum.ProductIdIntegrityMonitorAddon]: () => 'GravityZone Integrity Monitoring',
  [LicenseProductIdEnum.ProductIdIntegrityMonitorEs90DaysStorage]: () =>
    'GravityZone Integrity Monitoring 90 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdIntegrityMonitorEs180DaysStorage]: () =>
    'GravityZone Integrity Monitoring 180 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdIntegrityMonitorEs365DaysStorage]: () =>
    'GravityZone Integrity Monitoring 365 days Data Retention Add-on',
  [LicenseProductIdEnum.ProductIdCoreOnlineProduct]: () => 'GravityZone Small Business Security',
  [LicenseProductIdEnum.ProductIdNadAndEraAddon]: () => 'Network Attack Defense and Risk Management',
  [LicenseProductIdEnum.ProductIdWebAccessAndDeviceControlAddon]: () => 'Web Access and Device Control',
  [LicenseProductIdEnum.ProductIdMdr]: () => 'Bitdefender MDR',
  [LicenseProductIdEnum.ProductIdMdrPremium]: () => 'MDR Premium',
  [LicenseProductIdEnum.ProductIdMdrPlus]: () => 'Bitdefender MDR Plus',
  [LicenseProductIdEnum.ProductIdXdrSensitiveDataSensors]: () => 'Bitdefender XDR Sensor - Business Applications',
  [LicenseProductIdEnum.ProductIdBreachWarranty]: () => 'MDR Breach Warranty',
  [LicenseProductIdEnum.ProductIdBreachWarrantyPlus]: () => 'MDR Breach Warranty Plus',
  [LicenseProductIdEnum.ProductIdBreachWarrantyPlusOver1000]: () => 'MDR Breach Warranty Plus',
  [LicenseProductIdEnum.ProductIdComplianceManager]: () => 'GravityZone Compliance Manager',
  [LicenseProductIdEnum.ProductIdPhasrAddon]: () => 'Proactive Hardening and Attack Surface Reduction',
  [LicenseProductIdEnum.ProductIdExposureManagement]: () => 'GravityZone External Attack Surface Management',
  [LicenseProductIdEnum.ProductIdXdrBundle]: () => 'Bitdefender GravityZone Defense XDR',
};
